import { getStoreAccessors } from 'typesafe-vuex';

import { CatalogsMatcherTaskState } from './state';
import { State } from '../state';
import { ICatalogsMatcherTask } from '@/interfaces/catalogs-matcher';

export const getters = {
  CatalogsMatcherTasks: (state: CatalogsMatcherTaskState) => state.tasks,
  oneCatalogsMatcherTask: (state: CatalogsMatcherTaskState) => (taskId: number) => state.tasks.find(
    (task: ICatalogsMatcherTask) => task.id === taskId),
};

const { read } = getStoreAccessors<CatalogsMatcherTaskState, State>('');

export const readOneCatalogsMatcherTask = read(getters.oneCatalogsMatcherTask);
export const readCatalogsMatcherTasks = read(getters.CatalogsMatcherTasks);
